module.exports = __webpack_public_path__ + "static/img/clients_xiangyuan.31c57e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/clients_xiangyuan.png
// module id = wJAs
// module chunks = 2